import React from "react";

const ResearchSection = () => {
  return (
    <div className="bg-gray-100 py-8 sm:py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-center">
          <div className="w-full lg:w-2/5 mb-8 lg:mb-0 text-left">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 font-dmSans">
              Experience the Future of Research Insights
            </h2>
            <p className="text-sm sm:text-base mb-4 font-inter">
              Get hands-on with our advanced features and see the difference for
              yourself.
            </p>
            <ul className="text-sm sm:text-base mb-6 sm:mb-8 space-y-2">
              <li className="flex items-center">
                <span className="text-blue-500 mr-2">✦</span>
                Context-aware natural language search and discovery
              </li>
              <li className="flex items-center">
                <span className="text-blue-500 mr-2">✦</span>
                Embark on a journey of data-driven decision-making
              </li>
              <li className="flex items-center">
                <span className="text-blue-500 mr-2">✦</span>
                Single permission model for data + AI
              </li>
            </ul>
            <button className="w-full sm:w-auto px-6 py-2 bg-black text-white rounded-lg hover:bg-black/95 transition-all duration-300">
              Get Started
            </button>
          </div>

          <div className="w-full lg:w-1/2 mt-8 lg:mt-0 flex justify-center">
            <div className="p-4 border-2 border-gray-300 rounded-3xl shadow-lg overflow-hidden w-full sm:w-3/4 flex items-center justify-center">
              <img
                src="images/market.png"
                alt="Market Research"
                className="w-full rounded-3xl transform transition-transform duration-500 hover:scale-110"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResearchSection;
